module.exports = __webpack_public_path__ + "static/img/rotate2.f26676f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rotate2.jpg
// module id = b9Xn
// module chunks = 49